
// local y del servidor

var URL_BACKEND;
var DOMINIO_SERVIDOR;
var URL_SUBIR_ARCHIVO;
var URL_RESPUESTAS_CORRECTAS;
var URL_RESULTADO_CARRERA;
var URL_PLANTILLA_EXCEL;
var URL_REPORTE_INDIVIDUAL_ASPIRANTE;
var URL_EXPEDIENTE_REPORTES_ENVIADOS_POR_CORREO;
var URL_ASPIRANTES_PENDIENTES_REALIZAR_EXAMEN;
var URL_ASPIRANTES_INSCRITOS;
var URL_REPORTE_PROMEDIO_RESULTADOS_POR_MATERIA;
var URL_REPORTE_PROMEDIO_RESULTADOS_POR_CARRERA;
var URL_REPORTE_TODOS_PROMEDIOS_RESULTADOS_POR_CARRERA;
var URL_PROMEDIOS_ASPIRANTES_INGLES;
var URL_REPORTE_ASPIRANTE_POR_APLICACION;
var URL_PROMEDIOS_ASPIRANTES_INGLES_POR_CARRERA;
var URL_PROMEDIOS_INGLES_TODAS_CARRERAS;
var server, s;

if ( !true ) {

    server = "localhost:8000"
    s = ''

} else {
    //cuando esté en local:
    // server = "localhost/exameningreso/backend";
    // s = ''
    //cuando esté en servidor:
    server = "exameningreso.utescuinapa.edu.mx/backend";
    s = 's'

}




URL_BACKEND = `http${s}://${ server }/functions/fetch.php`
DOMINIO_SERVIDOR = `http${s}://${ server }`
URL_SUBIR_ARCHIVO = `http${s}://${ server }/functions/subirArchivo.php`
URL_RESPUESTAS_CORRECTAS = `http${s}://${server}/reportes/respuestasCorrectas.php`;
URL_RESULTADO_CARRERA = `http${s}://${server}/reportes/resultado_carrera.php`;
URL_PLANTILLA_EXCEL = `http${s}://${ server }/data/plantilla_aspirante_examen.xlsx`;
URL_REPORTE_INDIVIDUAL_ASPIRANTE = `http${s}://${server}/reportes/reporteIndividualAspirante.php`;
URL_EXPEDIENTE_REPORTES_ENVIADOS_POR_CORREO = `http${s}://${server}/reportes/expedienteReportesEnviadosPorCorreo.php`;
URL_ASPIRANTES_PENDIENTES_REALIZAR_EXAMEN = `http${s}://${server}/reportes/aspirantesPendientesRealizarExamen.php`;
URL_ASPIRANTES_INSCRITOS = `http${s}://${server}/reportes/reporteAspirantesInscritos.php`;
URL_REPORTE_PROMEDIO_RESULTADOS_POR_MATERIA = `http${s}://${server}/reportes/promedioResultadosPorMateria.php`;
URL_REPORTE_PROMEDIO_RESULTADOS_POR_CARRERA = `http${s}://${server}/reportes/promedioResultadosPorCarrera.php`;
URL_REPORTE_TODOS_PROMEDIOS_RESULTADOS_POR_CARRERA = `http${s}://${server}/reportes/todosPromediosResultadosPorCarrera.php`;
URL_PROMEDIOS_ASPIRANTES_INGLES = `http${s}://${server}/reportes/promediosAspirantesIngles.php`;
URL_REPORTE_ASPIRANTE_POR_APLICACION = `http${s}://${server}/reportes/reporteAspirantePorAplicacion.php`;
URL_PROMEDIOS_ASPIRANTES_INGLES_POR_CARRERA = `http${s}://${server}/reportes/promediosAspirantesInglesPorCarrera.php`;
URL_PROMEDIOS_INGLES_TODAS_CARRERAS = `http${s}://${server}/reportes/promediosInglesTodasCarreras.php`;

const clientId = `1006356263827-7fasqe2n40n74ibaanca59p06qdsl582.apps.googleusercontent.com`;


export {
  URL_BACKEND,
  clientId,
  DOMINIO_SERVIDOR,
  URL_SUBIR_ARCHIVO,
  URL_RESPUESTAS_CORRECTAS,
  URL_PLANTILLA_EXCEL,
  URL_RESULTADO_CARRERA,
  URL_REPORTE_INDIVIDUAL_ASPIRANTE,
  URL_EXPEDIENTE_REPORTES_ENVIADOS_POR_CORREO,
  URL_ASPIRANTES_PENDIENTES_REALIZAR_EXAMEN,
  URL_ASPIRANTES_INSCRITOS,
  URL_REPORTE_PROMEDIO_RESULTADOS_POR_MATERIA,
  URL_REPORTE_PROMEDIO_RESULTADOS_POR_CARRERA,
  URL_REPORTE_TODOS_PROMEDIOS_RESULTADOS_POR_CARRERA,
  URL_PROMEDIOS_ASPIRANTES_INGLES,
  URL_REPORTE_ASPIRANTE_POR_APLICACION,
  URL_PROMEDIOS_ASPIRANTES_INGLES_POR_CARRERA,
  URL_PROMEDIOS_INGLES_TODAS_CARRERAS
};
